import React, {Component} from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import SimpleModalComponent from '../../../../shared/modal/SimpleModalComponent'
import {LevelContainer, ScoreContainer} from '../../containers/LevelContainer'
//import {DeleteScoreKey} from './SharedLevelComponent'
import {DiceScorePad} from './SharedLevelComponent'

class ScoreKey extends Component {
    triggerScore = () => {
        const {value, weight} = this.props
        if (this.props.onChange) this.props.onChange(value * weight)
    }

    render() {
        const {value, weight} = this.props
        const d = value * weight - value * 3
        let v = d > 0 ? '+' + d : d
        if (value === 1) {
            v = (weight === 0 ? '/' : 1 * weight)
        } else if (value > 1 && weight === 3) {
            v = '='
        }
        return (
            <div className="col-md-4 col-sm-4  col-xs-4 text-center padkey" onClick={this.triggerScore}>
                {v}
            </div>
        )
    }
}


class ScorePad extends Component {

    triggerScore = (v) => {
        if (this.props.onChange) this.props.onChange(v)
    }

    render() {
        const {key} = this.props.conf.config
        const keys = []
        for (let i = 0; i < 6; i++) {
            keys.push(<ScoreKey onChange={this.triggerScore} key={key + '-' + i} weight={i} value={key}/>)
        }

        //keys.push(<DeleteScoreKey size={12} onChange={this.triggerScore} key={key + '-x'} value={'x'}/>)

        return (
            <div className="row">
                <div className="col-md-3 col-sm-3 col-xs-3 text-center"/>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row pad">
                        {keys}
                    </div>
                </div>
            </div>
        )
    }
}


class PadScorePadWrapper extends Component {
    render() {
        return (<DiceScorePad onChange={this.props.onChange}>
            {this.props.children}
        </DiceScorePad>)
    }
}

class ScoreComponent extends Component {

    constructor() {
        super()
        this.state = {
            edit: false
        }
    }

    triggerScore = (v) => {
        const {player, conf} = this.props
        if (this.props.onChange) this.props.onChange(player, conf, v)
        this.setState({
            edit: false
        })
    }

    editScore = () => {
        const {player, conf} = this.props
        const content = (<PadScorePadWrapper  onChange={this.triggerScore}>
            <ScorePad onChange={this.triggerScore} conf={conf}/>
        </PadScorePadWrapper>)
        return this.state.edit ?
            <SimpleModalComponent title={'les ' + conf.config.key + ' pour ' + player.name} content={content}
                                  close={e => this.toggleEditScore(false)}/> : null
    }

    toggleEditScore = (status) => {
        this.setState({
            edit: typeof status !== 'undefined' ? status : !this.state.edit
        })
    }

    display = (score, m) => {

        const r = m * (score / m) - m * 3

        if (r === 0) {
            return '='
        } else if (r < 0) {
            return r
        }
        return '+' + r
    }

    render() {
        const {player, conf, highlight } = this.props
        const _score = player.scoreBoard.find(o => o.id === conf.id)
        const score = _score ? _score.value : 0
        let v = this.display(score, conf.config.key)

        if (conf.config.key === 1) v = score > 0 ? '+' + score : '/';

        return (<ScoreContainer className={highlight ? ' highlight ' : ''} level={this.props.conf}>
            {this.editScore()}
            <span onClick={this.toggleEditScore}>{_score ? v : ''}</span>
        </ScoreContainer>)
    }
}


export default class NumLevelComponent extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
    }

    saveScore = (player, level, v) => {
        const playerScoreBoard = this.store.players.get(player.id).get('scoreBoard').filter(s => s.id !== level.id)
        if (v !== 'x') {
            playerScoreBoard.push({id: level.id, value: v})
        }
        this.store.players.get(player.id).set('scoreBoard', playerScoreBoard)
    }

    render() {
        const level = this.props.level
        const currentPlayer = this.store.players.toJSON().sort((a,b) => a.scoreBoard > b.scoreBoard).shift()
        const scores = this.store.players.toJSON().map(player => {
            return <ScoreComponent highlight={currentPlayer.id === player.id} onChange={this.saveScore} key={player.id} player={player} conf={level}/>
        })
        return (<LevelContainer className={this.props.className} name={level.config.name}>{scores}</LevelContainer>)
    }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/NumLevelComponent.jsx